import { FormControl } from "@angular/forms";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
import { GridActionsService } from 'src/app/data-grid/grid-actions.service';
import { HeaderService } from "src/app/components/header/header.service";
import { SettingsService } from "src/app/services/settings.service";
import { filter, takeUntil } from "rxjs/operators";
import { ShipyardService } from "../shipyard.service";
import { UpgradeFeemiumDialogComponent } from './../upgrade-feemium-dialog/upgrade-feemium-dialog.component';
import { DialogActions } from "./../../../components/dialogs/dialog.model";
import { SnackbarComponent } from '../../../components/snackbar/snackbar.component';
import { MixpanelService } from "src/app/services/mixpanel.service";
import { Subject } from "rxjs";

@Component({
  selector: "app-create-seller-central-shipments",
  templateUrl: "./create-seller-central-shipments.component.html",
  styleUrls: ["./create-seller-central-shipments.component.scss"],
})
export class CreateSellerCentralShipmentsComponent implements OnInit,OnDestroy {
  actions: DialogActions[];
  warehouses = [];
  selectedWarehouse;
  warehouse: FormControl = new FormControl();
  payload: any;
  tabIndex: number = 0;
  textIndex: number = 0;
  account: string;
  qty: number;
  itemCount: number;
  createdShipmentsIds: number[];
  lastWhUser;
  warehouseExists = true;
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CreateSellerCentralShipmentsComponent>,
    private settingsService: SettingsService,
    private shipyardService: ShipyardService,
    private headerService: HeaderService,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private gridActionService: GridActionsService,
    private mixpanelService: MixpanelService
  ) {}

  ngOnInit(): void {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e[0]));
    this.settingsService
        .GetLastUsedWarehouse(this.account)
        .pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
          if (res) this.lastWhUser = res;
        });
    this.settingsService
      .GetAllWarehouses()
      .pipe(takeUntil(this.destroy$)).subscribe((e: any[]) => {
        this.warehouses = e;
          if (this.warehouses && this.warehouses.length >= 1) {
            if (this.lastWhUser &&
                this.warehouses.findIndex((res) => res.id == this.lastWhUser) != -1) {
              const selectWareHouse = this.warehouses.find((res) => res.id === this.lastWhUser)
              this.warehouse.setValue(selectWareHouse);
            } else {
              this.warehouse.setValue(this.warehouses[0]);
            }
          }
          if (this.warehouses === null || this.warehouses.length === 0) {
            this.warehouseExists = false;
            this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: 'No Warehouse exist, please create one',
                    action: 'Dismiss',
                    type: 'error',
                  },
                }
            );
          }
      });

    this.headerService.remoteActionBroadcaster
      .pipe(filter((e: any) => e.action === "plan all"))
      .subscribe((e: any) => {
        this.createdShipmentsIds = e.response.resultUrl;
        if (!e.response.completed) {
          this.tabIndex = 3;
          this.actions = [
            {
              text: "Close",
              isDisabled: false,
            },
          ];
        } else {
          this.tabIndex = 2;
          this.actions = [
            {
              text: "Go to Shipment",
              buttonStyle: "underline",
              isDisabled: false,
            },
            {
              text: "Close",
              isDisabled: false,
            },
          ];
        }
      });

    this.payload = this.shipyardService.skusToAddToShipment.map((e) => {
      return {
        sku: e.sku.AccountSkuId,
        qty: e.qty,
      };
    });

    this.qty = this.payload.reduce((e, i) => e + i.qty, 0);
    this.itemCount = this.payload.length;

    this.actions = [
      {
        isDisabled: true,
        text: "Submit",
      },
    ];

    this.warehouse.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.selectedWarehouse = e;
      this.actions[0].isDisabled = false;
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  openShipment(shipmentId) {
    window.open(shipmentId, "_blank");
  }

  createNewWarehouse(type: any) {
    this.dialogRef.close({ type });
  }

  dialogAction(e) {
    if (e === "Submit") {
      this.mixpanelService.track('Created Seller Central Shipment');
      const payload = {
        account: this.account,
        fromWareHouseId: this.selectedWarehouse.id,
        skus: this.payload,
      };

      this.shipyardService.PlanAll(payload).pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.tabIndex = 1;
        setTimeout(() => {
          this.textIndex = 1;
        }, 10000);
        setTimeout(() => {
          this.textIndex = 2;
        }, 20000);
        this.actions = [
          {
            isDisabled: true,
            text: "Proccessing",
          },
        ];
      });
    } else if (e === "Go to Shipment") {
      this.openShipment(this.createdShipmentsIds);
    } else if (!e || e === "Close") {
      this.close();
    }
  }

  upgrade() {
    this.dialogRef.close();
    this.dialog.open(UpgradeFeemiumDialogComponent, {
      width: "500px",
    }).afterClosed().pipe(filter(e => e === "Continue")).subscribe(() => {
      this.gridActionService.createDraft();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
